<!--
/*******************************************************************************
*@ 컴포넌트명   : RadioBox.vue
*@ 컴포넌트설명 : radio 공통컴포넌트
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="form-row">
    <div class="item-tit">
      {{title || $t(titleI18n)}}
      <required v-if="isValidator && useRequired" />
    </div>
    <vuelidate-form
      :validator="isValidator? $v.value : null"
      :validator-params="errMsgParam"
      :messages="errMsg"
    >
      <div class="item-desc">
        <div :class="['form-check-group', isHorizontal? '--type1':'']">
          <template v-for="(data, i) in dataList">
            <div class="form-check" :key="i">
              <input
                type="radio"
                class="form-check-input"
                :name="id"
                :id="`${id}-${i}`"
                :value="data.value"
                v-model="checkedValueData"
              />
              <label
                :for="`${id}-${i}`"
                class="form-check-label"
              >{{i18nUse? $t(data.text):data.text}}</label>
            </div>
          </template>
        </div>
      </div>
    </vuelidate-form>
  </div>
</template>

<script>
import { commonProps, valueProps, validation, radioNCheckBoxProps } from "@/mixins/basicComponent";
import BaseContent from "@/components/BaseContent";
import { required } from "vuelidate/lib/validators";
export default {
  extends: BaseContent,
  mixins: [commonProps, valueProps, validation, radioNCheckBoxProps],
  props: {
    errMsg: Object,
  },
  data() {
    return {
      inputValue: "",
    };
  },
  beforeMount() {
    if (!_.isNil(this.checkedValueData)) {
      this.checkedValueData = this.value;
    } else if (this.defaultCheckedValue) {
      this.checkedValueData = this.defaultCheckedValue;
      this.$emit("update:value", this.defaultCheckedValue);
    }
  },
  mounted() {},
  validations() {
    let customValidations = {};
    if (this.$attrs) {
      for (const key in this.$attrs) {
        if (key == this.$config.VALIDATOR_REQUIRED) {
          customValidations = {
            ...customValidations,
            required,
          };
          this.useRequired = true;
        }
      }
    }

    return {
      value: customValidations,
    };
  },
  computed: {
    checkedValueData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
  methods: {
    /**
     * 초기화
     */
    init() {
      this.$emit("update:value", "");
      if (this.isValidator) {
        this.$v.value.$reset();
      }
    },
    /**
     * set value
     * @param {String} value 변경할 데이터
     */
    setValue(value) {
      this.$emit("update:value", value);
      if (this.isValidator) {
        this.$v.value.$touch();
      }
    },
  },
};
</script>